<template>
  <div class="card-container">
    <ul>
      <li class="card" v-for="box in boxes">
        <img :src="checkMarkAsset"/>
        <h2>{{$t(`${view}.CARD_CONTAINER_${box}_HEADING`)}}</h2>
        <div v-html="$t(`${view}.CARD_CONTAINER_${box}_BODY`)"></div>
      </li>
    </ul>
  </div>
</template>

<script>

import style from 'brave-cards/components/card-container.scss'
import checkMarkAsset from 'assets/img/bluecheck.png'
export default {
  data () {

    return {
      checkMarkAsset
    }
  },
  props: ['boxes', 'view']
}
</script>



// WEBPACK FOOTER //
// lib/brave-cards/components/card-container.vue